import React, { useCallback, useEffect, useState } from "react";
import GetWorkflowMainCategoryService from "../../../../../../Service/OPSServices/WorkflowsService/GetWorkflowMainCategoryService";
import { connect } from "react-redux";
import { Button, Card, CardBody, CardTitle, Col, Container, Input, Label, Row } from "reactstrap";
import WorkflowPhasesPage from "./Components/WorkflowPhasesPage";
import { useHistory } from "react-router-dom";
import FetchAllTaskByUser from "../../../../../../Service/OPSServices/WorkflowsService/FetchAllTaskByUser";
import ReactTable from "react-table";
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import {  faDownload} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import WorkflowSettings from "./SettingsComponents/WorkflowSettings";
import CustomModal from "../../../../../Components/Modals/CustomModal";

function WorkflowsMainPage(props) {
  
  const [selectedStore, setSelectedStore] = useState("");
  const [workflowMainCategory, setWorkflowMainCategory] = useState([]);
  const [workflowPhases, setWorkflowPhases] = useState([]);
  const [workflowPhasesList, setWorkflowPhasesList] = useState("");
  const [workflowPhasesPage, setWorkflowPhasesPage] = useState(false);
  const [selectedWorkflowMasterId, SetSelectedWorkflowMasterId] = useState();

  const [userTaskData, setUserTaskData] = useState([]);
  const [allTaskData, setAllTaskData] = useState([]);
  const [statistics, setStatistics] = useState([]);
  const [statusCounts, setStatusCounts] = useState([]);
  const [overallStatistics, setOverallStatistics] = useState([]);

  const [searchText, setSearchText] = useState('');
  const [teamMemberList, setTeamMemberList] = useState();
  const [loggedUserId, setLoggedUserId] = useState();
  const [executorId, setExecutorId] = useState();
  const [statusFilter, setStatusFilter] = useState('All');

  const [selectedTask, setSelectedTask] = useState();
  const [flag, setFlag] = useState(false);

  const [selectedStoreData, setSelectedStoreData] = useState({
    integerId: "",
    storeName: "",
  });

  const [settingsWorkflowId, setSettingsWorkflowId] = useState(1);
  const [workflowSettingsModal, setWorkflowSettingsModal] = useState(false);
  const [settingsWorkflowPhasesList, setSettingsWorkflowPhasesList] = useState([]);
  const [isVisibleSettingButton, setIsVissibleSettingButton] = useState(false);

  useEffect(() => {
    fetchLatestData();
    if (props.isMyworksScreen === true) {
      setSearchText(props.notificationsDetails.searchparams || "");
    }
  }, []);

  useEffect(() => {
    if (workflowPhases && settingsWorkflowId) {
      const filteredPhases = workflowPhases.filter(
        (phase) =>
          Number(phase.WorkflowsMaster) === Number(settingsWorkflowId)
      );
      setSettingsWorkflowPhasesList(filteredPhases);
    }
  }, [workflowPhases, settingsWorkflowId]);

  const workflowSettings = () => {
    setWorkflowSettingsModal(!workflowSettingsModal);
    if(workflowSettingsModal){
      window.location.reload()
    }
  };

  const fetchLatestData = () => {
    GetWorkflowMainCategoryService(props.token).then((res) => {
      if (res) {
        console.log(res)
        setIsVissibleSettingButton(res.isVisibleTaskSetting)
        setWorkflowMainCategory(res.masterWorkflows);
        setWorkflowPhases(res.workflowPhases);
      }
    });

    FetchAllTaskByUser(props.token).then((res) => {
      if (res) {
        setTeamMemberList(res.teamMembers);
        setStatistics(res.statistics);
        setStatusCounts(res.statusCounts);
        setExecutorId(res.loggedUserId);
        setLoggedUserId(res.loggedUserId);
        setOverallStatistics(res.overallStatistics);

        const filteredTasks = res.taskList.filter(
          task => task.executor === res.loggedUserId
        );
        // const filteredTasks = isPreviewMode
        //   ? taskList
        //   : taskList.filter(task => task.WorkflowPhases === currentPhaseId);

        setUserTaskData(filteredTasks);
        setAllTaskData(res.taskList);
      }
    });
  };

 
  const handleStoreChange = (e) => {
    console.log(e.target.value);
    props.adProfiles.map((store) => {
      if (e.target.value == store.integerID) {
        setSelectedStore(e.target.value);
        console.log(e.target.value)
        setSelectedStoreData({
          integerId: store.integerID,
          storeName: store.name
        });
      }
    });
  };
  const handleWorkflowMaster = (workflowId) => {
    SetSelectedWorkflowMasterId(workflowId);
    const filteredPhases = workflowPhases && workflowPhases.filter(phase => phase.WorkflowsMaster == workflowId).sort((a, b) => a.id - b.id);
    setWorkflowPhasesList(filteredPhases)
  };

  const handleBackButtonToWorkflow = () => {
    fetchLatestData();
    setWorkflowPhasesPage(false);
    SetSelectedWorkflowMasterId(null)
    setSelectedStore({integerID:''})
    setSelectedStoreData(null)
  };
  const quickOpenWorkflowByStoreName = (data) =>{
    console.log(data)
    setFlag(true)
    setSelectedTask(data)
    setSelectedStoreData({integerId:data.integerId,storeName:data.storeName})
    handleWorkflowMaster(data.workflowId)
    setWorkflowPhasesPage(true)
  }
  const handaleSearchStoreHealth=(e)=>{
    setSearchText(e.target.value)
  }

  const filterStorehealthAllTasks = allTaskData && allTaskData.filter((row) => {
    
    const filterRadioStatus= statusFilter === 'All'|| statusFilter === row.status
    const assignedToFilter = row.executor == executorId;
    const storeName =( row.storeName ||' ').toLowerCase().includes(searchText.toLowerCase());
    const workFlow =(row.workFlow ||'').toLowerCase().includes(searchText.toLowerCase());
    const phase = (row.phase || '').toLowerCase().includes(searchText.toLowerCase());
    const task =(row.task ||'').toLowerCase().includes(searchText.toLowerCase());
    const status =(row.status ||'').toLowerCase().includes(searchText.toLowerCase());
    const executorName =  (row.executorName ||'').toLowerCase().includes(searchText.toLowerCase());
    if(executorId)
    {
    const assignedToFilter = row.executor == executorId;
    return filterRadioStatus &&  assignedToFilter && (storeName || workFlow || phase || status || executorName || task);
    }
    else
    {
      return filterRadioStatus && (storeName || workFlow || phase || status || executorName || task);
    }
  });

  // const filterStorehealthAllTasks= allTaskData.filter((row)=>{
  //   const storeName =( row.storeName ||' ').toLowerCase();
  //   const workFlow =(row.workFlow ||'').toLowerCase();
  //   const phase = (row.phase || '').toLowerCase();
  //   const task =(row.task ||'').toLowerCase();
  //   const status =(row.status ||'').toLowerCase();
  //   return storeName.includes(searchText.toLowerCase())||workFlow.includes(searchText.toLowerCase())||phase.includes(searchText.toLowerCase())||task.includes(searchText.toLowerCase())||status.includes(searchText.toLowerCase());
  //   // return storeName.includes(searchText.toLowerCase())|| workFlow.includes(searchText.toLowerCase())|| phase.includes(searchText.toLowerCase())||task.includes(toLowerCase())||status.includes(toLowerCase())
  // });

  const columns=[
    {
      Header:' Store Name',
      accessor:'storeName',
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100 cursor-pointer" onClick={()=>{quickOpenWorkflowByStoreName(cellInfo.original)}}>
          <p className="m-0">{cellInfo.value}</p>
        </div>
      ),
    },
    {
      Header: 'Workflow Name',
      accessor:'workflow',
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p className="m-0">{cellInfo.value}</p>
        </div>
      ),
    },
    {
      Header:'Phase',
      accessor:'phase',
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p className="m-0">{cellInfo.value}</p>
        </div>
      ),
    },
    {
      Header:'Tasks',
      accessor:'task'
    },
    {
      Header:'Status',
      accessor:'status',
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p className="m-0">{cellInfo.value}</p>
        </div>
      ),
    }

  ]
  const allTasksColumns=[
    {
      Header:' Store Name',
      accessor:'storeName',
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100 cursor-pointer" onClick={()=>{quickOpenWorkflowByStoreName(cellInfo.original)}}>
          <p className="m-0">{cellInfo.value}</p>
        </div>
      ),
    },
    {
      Header: 'Workflow Name',
      accessor:'workflow',
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p className="m-0">{cellInfo.value}</p>
        </div>
      ),
    },
    {
      Header:'Phase',
      accessor:'phase',
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p className="m-0">{cellInfo.value}</p>
        </div>
      ),
    },
    {
      Header:'Tasks',
      accessor:'task'
    },
    {
      Header:'Assigned Task',
      accessor:'executorName',
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p className="m-0">{cellInfo.value}</p>
        </div>
      ),
    },
    {
      Header:'Status',
      accessor:'status',
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p className="m-0">{cellInfo.value}</p>
        </div>
      ),
    }

  ]
  const now = new Date();

const year = now.getFullYear();
const month = String(now.getMonth() + 1).padStart(2, '0');
const day = String(now.getDate()).padStart(2, '0');
const hours = String(now.getHours()).padStart(2, '0');
const minutes = String(now.getMinutes()).padStart(2, '0');
const seconds = String(now.getSeconds()).padStart(2, '0');

const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

  const ExportCSV = (csvData, fileName) => {
    console.log('Download Called');
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    console.log('Download Called')
    const exportToCSV = (csvData, fileName) => {
        console.log(csvData)
        console.log(fileName)
        const ws = XLSX.utils.json_to_sheet(csvData);
            
        const wb = { Sheets: {'SW_Workflows_Tasks_Status':ws }, SheetNames: ['SW_Workflows_Tasks_Status'] };                
             
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], {type: fileType});
        console.log('before save')
        FileSaver.saveAs(data, fileName + fileExtension);   
                       
        };

    exportToCSV(csvData, fileName);
        
    }
  const handleChangeAssignedTo=(e)=>{
    setExecutorId(e.target.value)
    console.log(e.target.value)
  }
  const handleSettingsWorkflowChange = (workflowId) => {
    setSettingsWorkflowId(workflowId);
  
    const filteredPhases =
      workflowPhases &&
      workflowPhases.filter(
        (phase) => Number(phase.WorkflowsMaster) === Number(workflowId)
      );
  
    setSettingsWorkflowPhasesList(filteredPhases || []);
  };
  return (
    <>
    
        {!workflowPhasesPage ? (
          <Row>
            <Col md={12}>
              <Card className={props.isMyworksScreen == true ? 'd-none' : 'p-4 card-of-problemarea'}>
                <Row>
                  <Col md={12}>
                  <div className="d-flex position-relative">
                  <select
                      id="StoreList"
                      name="StoreList"
                      onChange={(e) => handleStoreChange(e)}
                      value={selectedStore.integerID}
                      className="form-control w-25"
                    >
                      <option value="">--Select Store--</option>
                      {props.adProfiles.map((store) => (
                        <option value={store.integerID}> {store.name}</option>
                      ))}
                    </select>
                    <select
                      onChange={(e) => handleWorkflowMaster(e.target.value)}
                      value={selectedWorkflowMasterId}
                      className="form-control ml-5 w-25"
                    >
                      <option value="">--Select Workflow--</option>
                      {workflowMainCategory &&
                        workflowMainCategory.map((wf) => (
                          // <option value={wf.id} > {wf.name}</option>
                          <option value={wf.id} disabled={!selectedStore || !selectedStoreData}> {wf.name}</option>
                        ))}
                    </select>
                    <Button
                        className="btn-background-color ml-5"
                        onClick={() => setWorkflowPhasesPage(true)}
                        disabled={!selectedWorkflowMasterId || !selectedStoreData}
                        // disabled={!selectedWorkflowMasterId || !(selectedStore, selectedStoreData )}
                      >
                        Submit
                      </Button>
                      
                   {isVisibleSettingButton? <Button
                        className="btn-background-color text-right"
                        onClick={workflowSettings}
                        style={{
                          position: "absolute",
                          right: "0"
                        }}
                        // disabled={!settingsWorkflowId}
                      >
                        Settings
                    </Button>:''}
                  </div>
                  </Col>
                  
                </Row>
              </Card>

             
              <Card className="main-card card-of-problemarea mb-1 mt-2">
              <CardBody>
                <Row>
                  <Col md="12">
                    <CardTitle className='mt-2 border mb-0 p-2 text-center' style={{ fontSize: '17px', color: '#243837', backgroundColor: '#B1FA63' }}>OverAll Workflow Task Status</CardTitle>
                    <div className="d-flex border p-1 justify-content-around">
                    {
                        statusCounts ?
                          statusCounts.map((item) => (
                            <div className="border pt-2 pb-2 pl-2 pr-2 m-1" >
                              <h5 className="text-center" style={{fontSize: '18px'}}><b>{item.status}</b></h5>
                              <h6 className="text-center"><b>{item.count}</b></h6>
                            </div>
                          ))
                          :
                          <p>Loading Statistics...</p>
                      }
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>

              <Card className=" p-4 mt-2 card-of-problemarea">
              {/* <CardTitle>All Tasks</CardTitle> */}
              <Row>
                
                <Col md={12}>
                {
                  props.isMyworksScreen ==true?
                  <>
                    {props.notificationsDetails.action== true && props.notificationsDetails.action !=undefined?
                    <Card className="notification-card p-3 mb-2 card-of-problemarea">
                    <Row>
                      <Col md={10}>
                      <strong>{props.notificationsDetails.details}</strong>
                        </Col>
                        <Col md={2} className="text-end">
                        <Button 
                        close
                          onClick={()=> props.setNotificationsDetails({
                            tabs: 1,
                            details:'',
                            action:false,
                            searchparams:''
                    
                          })} 
                        className="close-button" 
                        />
                    </Col>
                    </Row>
                  </Card>
                :''}
                  </>:""

                }
              
                <div className="d-flex">
                  
                  <Input
                    type='text'
                    className='w-25 mb-3'
                    value={searchText}
                    placeholder="Search Text"
                    onChange={(e)=>handaleSearchStoreHealth(e)}/>

                      <select
                              className="form-control w-25 ml-3"
                              name="assignedto"
                              id="assignedto"
                            onChange={(e) => {
                              handleChangeAssignedTo(e);
                              
                            }}
                            >
                              <option value="">-- All --</option>
                              {teamMemberList &&
                                teamMemberList.map((member) => (
                                  <option
                                    key={member.employeeId}
                                    value={member.employeeId}
                                    selected={
                                        member.employeeId === loggedUserId
                                    }
                                  >
                                    {member.employeeName}
                                  </option>
                                ))}
                            </select>
                            <button
                              title="Download Workflows Tasks"
                            className="info-button-background-none ml-3 mb-3 "
                            onClick={() => ExportCSV(filterStorehealthAllTasks,'SW_Workflows_Tasks_Status_'+formattedDateTime)}>
                            <FontAwesomeIcon style={{ fontSize: '27px' }} icon={faDownload} />
                            </button>
                          </div>
                           
                            <div>

                      <label className='mr-3'>
                        <input
                          type='radio'
                          name='status'
                          checked={statusFilter === "All"}
                          value={statusFilter}
                          //  checked={status.status}
                          onChange={() => setStatusFilter('All')}
                          />&nbsp;
                          <b>All</b>
                        </label>
                  {
                    statusCounts && statusCounts.map((item)=>(
                      <label className='mr-3'>
                        <input
                          type='radio'
                          name='status'
                          value={statusFilter === item.status}
                          onChange={() => setStatusFilter(item.status)}
                          />&nbsp;
                          <b>{item.status}</b>
                        </label>
                    ))
                  }
                
                
                </div>
               
                </Col>

              </Row>
             
              <ReactTable
                data={filterStorehealthAllTasks}
                columns={allTasksColumns}
                className="-fixed -highlight -striped"
                getTheadProps={() => {
                  return {
                    style: {
                      overflowY: "hidden",
                      background: "#B1FA63",
                      color: "#243837",
                    },
                  };
                }}
                defaultPageSize={5}
                noDataText={"No Data Found."}
                />
              </Card>
              {/* <Card className=" p-4 mt-4 card-of-problemarea">
              <CardTitle>All Tasks</CardTitle>
              <Input
                  type='text'
                  className='w-25 mb-3'
                  placeholder="Search Text"
                  onChange={(e)=>handaleSearchStoreHealth(e)}/>
              <ReactTable
                data={filterStorehealthAllTasks}
                columns={allTasksColumns}
                className="-fixed -highlight -striped"
                getTheadProps={() => {
                  return {
                    style: {
                      overflowY: "hidden",
                      background: "#B1FA63",
                      color: "#243837",
                    },
                  };
                }}
                defaultPageSize={5}

                noDataText={"No Data Found."}
                />
              </Card> */}
            </Col>
          </Row>
        ) : (
          <WorkflowPhasesPage
            selectedTask={selectedTask}
            flag={flag}
            handleBackButtonToWorkflow={handleBackButtonToWorkflow}
            selectedWorkflowMasterId={selectedWorkflowMasterId}
            workflowPhases={workflowPhasesList}
            workflowMainCategory={workflowMainCategory}
            selectedStoreData={selectedStoreData}
          />
        )}
      <CustomModal
       header={
        <div className="d-flex align-items-center">
          <label className="mb-0 " style={{ minWidth: "100px" }}>
            Workflow : 
          </label>
      
          <select
            onChange={(e) => handleSettingsWorkflowChange(e.target.value)}
            value={settingsWorkflowId}
            className="form-control"
            style={{ width: "250px" }}
          >
            <option value="" disabled>--Select Workflow--</option>
            {workflowMainCategory &&
              workflowMainCategory.map((wf) => (
                <option key={wf.id} value={wf.id}>
                  {wf.name}
                </option>
              ))}
          </select>
        </div>
      }
        isOpen={workflowSettingsModal}
        toggle={workflowSettings}
        size={"xl"}
        className="curve-popup"
      >
        <WorkflowSettings 
        settingsWorkflowId={settingsWorkflowId}
        workflowPhases={settingsWorkflowPhasesList}
        workflowMainCategory={workflowMainCategory}
        selectedTask={selectedTask}
        flag={flag}
        isPreviewMode={true}  
        handleBackButtonToWorkflow={handleBackButtonToWorkflow}
        selectedStoreData={selectedStoreData}

        />
      </CustomModal>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    token: state.loggedUser.token,
    accessLevel: state.loggedUser.accessLevel,
    status: state.loggedUser.status,
    error: state.loggedUser.error,
    storeOverview: state.accountOverview.store.storeOverview,
    storeProducts: state.accountOverview.store.storeProducts,
    newUser: state.loggedUser.newUser,
    needsAdvertisingAPIAuth: state.loggedUser.needsAdvertisingAPIAuth,
    user: state.LWA.user,
    isAuth: state.LWA.isAuth,
    enableMobileMenu: state.theme.enableMobileMenu,
    enableClosedSidebar: state.theme.enableClosedSidebar,
    adProfiles: state.accountOverview.landing.adProfiles,
  };
};

export default connect(mapStateToProps)(WorkflowsMainPage);
